import { Answer, Content, Score } from "../types";

export function markAnswer(content: Content, answer: Answer): Score {
  if (!answer)
    return {
      score: 0,
      values: []
    };
  let score = 0;
  const values: boolean[] = [];
  content.orderedValues.forEach((ans, index) => {
    const correct = answer[index] === ans;
    values.push(correct);

    if (correct) {
      score++;
    }
  });
  return {
    score: score / content.orderedValues.length,
    values
  };
}
